import { User } from "../models/userModel";
import { backendRequest } from "./backendApi";
import exceptionService from "./exceptionService";
const userProfileService = {
  async fetchProfile(userId: string): Promise<{ data: any; error: any }> {
    const r = await backendRequest("/profile/fetch");
    if (r.error) exceptionService.logError(r.error, "userProfileService.fetchProfile", userId);
    return r;
  },
  async updateProfile(profile: User, userId: string): Promise<Boolean> {
    const r = await backendRequest<boolean>("/profile/update", { profile });
    if (r.error) exceptionService.logError(r.error, "userProfileService.updateProfile", userId);
    return r.data === true;
  },
};
export default userProfileService;
